import type { AuthProvider } from './types'

export * from './types'
export * from './permissions'
export * from './config'

export type ProviderName = 'mock' | 'supabase'

export function currentProviderName(): ProviderName {
  return import.meta.env.VITE_AUTH_PROVIDER === 'supabase' ? 'supabase' : 'mock'
}

export function isDemoMode(): boolean {
  return currentProviderName() === 'mock'
}

let instance: Promise<AuthProvider> | null = null

/**
 * Both providers load through a dynamic import so each build ships only the
 * one it uses: a production build carries no mock implementation and no demo
 * credentials, and a demo build carries no Supabase SDK.
 */
export function getAuthProvider(): Promise<AuthProvider> {
  if (instance) return instance
  instance =
    currentProviderName() === 'supabase'
      ? import('./supabase-provider').then((m) => m.createSupabaseAuthProvider())
      : import('./mock-provider').then((m) => m.createMockAuthProvider())
  return instance
}
